import SubmitAnswerButton from "./SubmitAnswerButton";

export default SubmitAnswerButton;